import { Grid, Typography, Tooltip } from "@material-ui/core";
import React from "react";
import { useRepresentativeMock2 } from "souqh-react-redux-hooks/serviceProvider/storefront/useRepresentativeMock2";
import { useTheme } from "souqh-react-redux-hooks/serviceProvider/storefront/useTheme";
import Styles from "../../../Styles.module.css";
import { isMobileDevice, isTabletDevice } from "../../../utils/AppUtils";

function RepresentativeMock2(props) {
  const { primaryColor, secondaryColor } = useTheme();
  const { numberOfEmployees, yearsInBusiness } = useRepresentativeMock2();
  const averageResponseTime = props.averageResponseTime;
  const hasYearsInBusinessProp = Object.prototype.hasOwnProperty.call(
    props,
    "yearsInBusiness"
  );
  const hasNumberOfEmployeesProp = Object.prototype.hasOwnProperty.call(
    props,
    "numberOfEmployees"
  );
  const resolvedYearsInBusiness = hasYearsInBusinessProp
    ? props.yearsInBusiness
    : yearsInBusiness;
  const resolvedNumberOfEmployees = hasNumberOfEmployeesProp
    ? props.numberOfEmployees
    : numberOfEmployees;
  const stats = [
    averageResponseTime && {
      label: "Average Response Time",
      value: averageResponseTime,
      showTooltip: true,
    },
    resolvedYearsInBusiness && {
      label: "Years in business",
      value: resolvedYearsInBusiness,
    },
    resolvedNumberOfEmployees && {
      label: "Number of Employees",
      value: resolvedNumberOfEmployees,
    },
  ].filter(Boolean);

  const mobileGridSize =
    stats.length === 1 ? 12 : stats.length === 2 ? 6 : 4;
  const desktopHeight =
    stats.length > 0 ? stats.length * 100 : 0;

  return (
    <Grid container justifyContent="flex-end">
      {stats.length > 0 && (
        <Grid
          container
          item
          xs={12}
          lg={4}
          style={{
            backgroundColor: primaryColor,
            borderRadius: isMobileDevice() || isTabletDevice() ? 0 : 8,
            height:
              isMobileDevice() || isTabletDevice() ? 100 : desktopHeight,
            width: isMobileDevice() ? 375 : 140,
            maxWidth: "unset",
            flexBasis:
              isMobileDevice() || isTabletDevice() ? "none " : "unset",
            padding: 5,
          }}
        >
          {stats.map((stat) => (
            <Grid
              key={stat.label}
              item
              lg={12}
              xs={mobileGridSize}
              container
              justifyContent="center"
              alignContent="center"
              direction="column"
            >
              <Typography
                variant="h6"
                style={{ color: secondaryColor }}
                align="center"
              >
                {stat.value}
              </Typography>
              {stat.showTooltip ? (
                <Tooltip title="Calculated by Souqh">
                  <Typography
                    variant="body1"
                    style={{ color: secondaryColor }}
                    align="center"
                  >
                    {stat.label}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography
                  variant="body1"
                  style={{ color: secondaryColor }}
                  align="center"
                >
                  {stat.label}
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
}

export default RepresentativeMock2;
